<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap">
        <a-form-model
          layout="inline"
          :model="searchForm.data">
          <a-form-model-item label="品牌">
            <a-select style="width: 180px" v-model="searchForm.data.brandId" allowClear>
              <a-select-option
                v-for="item in brand.data"
                :key="item.id"
              :value="item.id"
              :title="item.name">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="名称">
            <a-input v-model="searchForm.data.title" allowClear/>
          </a-form-model-item>
          <a-form-model-item>
            <a-button
                type="primary"
                plain
                icon="el-icon-search"
                      @click="getBrandNewsList">查询
            </a-button>
          </a-form-model-item>
        </a-form-model>
        <div>
          <a-button type="primary" @click="addBrandNews">
            {{ $t('ADD') || '添加' }}
          </a-button>
        </div>
      </div>

      <a-table
        :data-source="table.data"
        :scroll="{ y: 'calc(100vh - 410px)' }"
        row-key="id"
        style="width: 100%">
        <a-table-column
          data-index="title"
          title="标题"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="goodsBrand.name"
          title="品牌名称"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="subTitle"
          title="副标题"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="postAt"
          title="发表时间"
          width="180">
          <template slot-scope="text,record">
            <time-formatter :time="record.postAt" format="YYYY-MM-DD HH:mm:ss"/>
          </template>
        </a-table-column>
        <a-table-column
          data-index="coverPath"
          title="封面图片"
          width="180">
          <template slot-scope="text,record">
            <img
              style="width: 50px; height: auto"
              :src="record.coverPath"
              :preview-src-list="[record.coverPath]"
            />
          </template>
        </a-table-column>
        <a-table-column
          data-index="tags"
          title="标签"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION') || '操作'">
          <template slot-scope="text, record">
            <a-button type="link" @click="editBrandNews(record.id)">{{ $t('EDIT') || '编辑' }}
            </a-button>
            <a-button type="link" @click="deleteBrandNews(record.id)">删除
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
:footer="null"
             title="品牌新闻编辑"
             width="50%"
             mask-closeable="false"
             v-model="form.visible">
      <brandNews-edit
        v-if="form.visible"
        :brand-news-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </brandNews-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryGoodsBrands,
} from '@/api/goodsBrandApi';
import {
  _queryBrandNewss,
  _deleteBrandNews,
} from '@/api/brandNewsApi';
import BrandNewsEdit from './BrandNewsEdit.vue';
import TimeFormatter from '../../../components/TimeFormatter.vue';

async function getBrandNewsList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryBrandNewss({
    brandId: this.searchForm.data.brandId,
    title: this.searchForm.data.title,
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
}

function addBrandNews() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editBrandNews(brandNewsId) {
  this.form.data.id = brandNewsId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getBrandNewsList();
}

async function deleteBrandNews(brandNewsId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteBrandNews(brandNewsId);
      this.$message.success('删除成功');
      this.getBrandNewsList();
    },
  });
}

export default {
  name: 'BrandNewsList',
  components: {
    TimeFormatter,
    BrandNewsEdit,
  },
  data() {
    return {
      brand: {
        data: [],
      },
      searchForm: {
        data: {
          brandId: '',
          title: '',
        },
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'postAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getBrandNewsList,
    deleteBrandNews,
    editBrandNews,
    addBrandNews,
    closeForm,
  },
  async created() {
    const brandResult = await _queryGoodsBrands({});
    this.brand.data = brandResult.content;
    await this.getBrandNewsList();
  },
};
</script>

<style scoped>

</style>
